// extracted by mini-css-extract-plugin
export var createdDate = "_g1-1";
export var divider = "_g1-2";
export var headerDivider = "_g1-3";
export var messagesCard = "_g1-0";
export var messagesContainer = "_g1-6";
export var messagesContainerWrapper = "_g1-4";
export var showLeftPanelButton = "_g1-8";
export var topButtons = "_g1-7";
export var withPadding = "_g1-5";